import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

export const normalizePaymentMethod = (m) => {
    const cleaned = String(m || '').trim().toLowerCase()
        .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
    return cleaned || 'unknown'
}

export const PAYMENT_LABELS = {
    cash: 'Cash', gcash: 'GCash', card: 'Card',
    credit_card: 'Credit Card', debit_card: 'Debit Card',
    paymongo: 'PayMongo', xendit: 'Xendit',
    bank_transfer: 'Bank Transfer', e_wallet: 'E-Wallet',
}

export const formatPaymentLabel = (m) =>
    PAYMENT_LABELS[m] || (m || 'Unknown').toString().replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())

/** Fetches raw payment transactions for a date range (+ optional branch). */
export function usePaymentMethods(startISO, endISO, branchId, enabled = true) {
    const [data, setData] = useState(null)
    useEffect(() => {
        if (!enabled) return
        let cancelled = false
        setData(null)
        let query = supabase
            .from('order_transactions')
            .select('order_transaction_id, payment_method, transaction_amount, status, created_at, orders!inner(branch_id)')
            .in('status', ['completed', 'paid'])
            .gte('created_at', startISO)
        if (endISO) query = query.lte('created_at', endISO)
        if (branchId) query = query.eq('orders.branch_id', branchId)
        query.then(({ data: rows, error }) => {
            if (cancelled) return
            if (error) { console.error('payment-methods error:', error); setData([]); return }
            setData(rows ?? [])
        })
        return () => { cancelled = true }
    }, [startISO, endISO, branchId, enabled])
    return data
}

/** Turns raw transactions into { methods, top, totalAmount, totalCount }. */
export function summarizePaymentMethods(transactions) {
    if (!transactions?.length) return { methods: [], top: null, totalAmount: 0, totalCount: 0 }
    const map = {}
    transactions.forEach(t => {
        const key = normalizePaymentMethod(t.payment_method)
        if (!map[key]) map[key] = { method: key, count: 0, amount: 0 }
        map[key].count += 1
        map[key].amount += Number(t.transaction_amount || 0)
    })
    const methods = Object.values(map).sort((a, b) => b.count - a.count)
    const totalCount = methods.reduce((s, m) => s + m.count, 0)
    const totalAmount = methods.reduce((s, m) => s + m.amount, 0)
    return { methods, top: methods[0] ?? null, totalAmount, totalCount }
}